import ExpandIcon from '@/public/images/survey/ic-expand-more.svg';

type Required = 'required' | 'optional';

export interface InputProps {
  id?: string;
  required?: Required;
  label: string;
  value: string;
  onClick: () => void;
  disabled?: boolean;
}

export const SelectInput = ({ id, label, value, onClick, required, disabled }: InputProps) => {
  return (
    <div>
      <label htmlFor={id} className={'body-14 block pb-1 pt-3 font-normal leading-5'}>
        <span className={'text-gray-700'}>{label}</span>
        {required === 'required' ? (
          <span className={'ml-0.5 inline-block text-blue-600'}>(필수)</span>
        ) : (
          required === 'optional' && <span className={'ml-0.5 inline-block text-gray-500'}>(선택)</span>
        )}
      </label>
      <button
        type={'button'}
        role={'combobox'}
        aria-autocomplete={'none'}
        id={id}
        disabled={disabled}
        className={'rounded-2.5 flex h-12 w-full items-center gap-2 border border-gray-200 pl-4 pr-2 disabled:bg-gray-100'}
        onClick={onClick}
      >
        <span className={'flex-1 text-left'}>{value}</span>
        <span className={'flex h-10 w-10 shrink-0 items-center justify-center text-gray-500'}>
          <ExpandIcon width={24} height={24} />
        </span>
      </button>
    </div>
  );
};
